var React = require('react');

function Tablet (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"7","y":"3","width":"18","height":"26","rx":"1","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("rect",{"x":"8","y":"22","width":"16","height":"2","fill":"currentColor","key":1}),React.createElement("circle",{"cx":"16","cy":"7","r":"1","fill":"currentColor","key":2})]);
}

Tablet.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Tablet;

Tablet.default = Tablet;
